const numberFormat = new Intl.NumberFormat('cs-CZ')
const decimalFormat = new Intl.NumberFormat('cs-CZ', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
})

const percentageFormat = new Intl.NumberFormat('cs-CZ', {
    style: 'percent',
})

const currencyFormat = new Intl.NumberFormat('cs-CZ', {
    style: 'currency',
    currency: 'CZK',
})

export function clamp(value, min, max) {
    return Math.min(max, Math.max(min, value))
}

export function formatNumber(number) {
    return numberFormat.format(number)
}

export function formatDecimal(number) {
    return decimalFormat.format(number)
}

export function formatPercentage(number) {
    return percentageFormat.format(number)
}

export function parse(value) {
    return parseFloat(value.replace(/\s/gi, '').replace(',', '.'))
}

export function parseInteger(value) {
    return parseInt(value.replace(/\s/gi, ''))
}

export function formatCurrency(value) {
    return currencyFormat.format(value)
}
